import { render, staticRenderFns } from "./PaginationWithoutRedirect.vue?vue&type=template&id=a56859ec&scoped=true&"
import script from "./PaginationWithoutRedirect.vue?vue&type=script&lang=js&"
export * from "./PaginationWithoutRedirect.vue?vue&type=script&lang=js&"
import style0 from "./PaginationWithoutRedirect.vue?vue&type=style&index=0&id=a56859ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56859ec",
  null
  
)

export default component.exports